import fileSaver from 'file-saver';
import * as CareLabelService from '../../../../services/care-label.service';
import { ERROR_MESSAGE } from '../../../../Components/helper';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import {
  GET_ALL_CARELABEL,
  GET_ALL_CARELABEL_GROUP,
  GET_CARELABEL_GROUP_ID,
  GET_ALL_TYPE_CARELABEL,
  GET_ALL_CARELABEL_GROUP_ID,
  UNMOUNT_CARE_GROUP,
  UNMOUNT_CARE_LIBRARY,
} from './CareLabel.type';

export const fetchCareLabel = (params) => async (dispatch) => {
  try {
    const res = await CareLabelService.getCareLabelLibrary(params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_ALL_CARELABEL,
        payload: res?.data ? res.data?.list : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const importCareLibrary = (data) => async () => {
  try {
    const res = await CareLabelService.uploadCareLibrary(data);
    if (res?.code === 200 && res.data) {
      toasterMsg(res.message, 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCareLibrary = (id, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deleteSingleCareLibrary(id);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`CARE_LABEL.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteMultiCareLibrary = (payload, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deleteMultipleCareLibrary(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`CARE_LABEL.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    toasterMsg(res.data?.errMsg, 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addCareLibrary = (payload, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.addCareLibraryService(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`CARE_LABEL.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    const msg = transactionMsg(`CARE_LABEL.${res.data.errMsg}`);
    toasterMsg(msg, 'danger');

    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editCareLibrary = (payload, id, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.editCareLibraryService(payload, id);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`CARE_LABEL.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    toasterMsg(transactionMsg(res.data?.errMsg), 'danger');
    return res;
  } catch (err) {
    toasterMsg(transactionMsg(err.toString()), 'danger');
  }
};

export const fetchCareLabelGroup = (searchText) => async (dispatch) => {
  try {
    const res = await CareLabelService.getCareLabelGroup(searchText);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_ALL_CARELABEL_GROUP,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deleteCareGroup = (data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.deleteCareGroupService(data);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`CARE_LABEL.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCareLabelGroupByID = (id, params) => async (dispatch) => {
  try {
    const res = await CareLabelService.getCareLabelGroupId(id, params);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_CARELABEL_GROUP_ID,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchAllCareLabelLibrary = () => async (dispatch) => {
  try {
    const res = await CareLabelService.getAllCareLabelLibrary();
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_ALL_TYPE_CARELABEL,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchCareLabelGroupByUserId = (userId) => async (dispatch) => {
  try {
    const res = await CareLabelService.getCareLabelGroupUserId(userId);
    if (res?.code === 200 && res.data) {
      await dispatch({
        type: GET_ALL_CARELABEL_GROUP_ID,
        payload: res?.data ? res.data : [],
      });
      return res;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updateCareLabelGroup = (id, data, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.editCareLabelGroup(id, data);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`CARE_LABEL.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    toasterMsg(transactionMsg(res.data?.errMsg), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveCareLabelGroup = (payload, transactionMsg) => async () => {
  try {
    const res = await CareLabelService.saveCareLabelGroupService(payload);
    if (res?.code === 200 && res.data) {
      const msg = transactionMsg(`CARE_LABEL.${res.message}`);
      toasterMsg(msg, 'success');
      return res;
    }
    toasterMsg(transactionMsg(res.data?.errMsg), 'danger');
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const unmountCareGroup = () => async (dispatch) => {
  try {
    await dispatch({
      type: UNMOUNT_CARE_GROUP,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
export const unmountCareLibrary = () => async (dispatch) => {
  try {
    await dispatch({
      type: UNMOUNT_CARE_LIBRARY,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadCareLibrary = (data, t) => async () => {
  try {
    const res = await CareLabelService.exportExcelService(data);
    if (res) {
      if (data?.type) {
        fileSaver.saveAs(res, 'Sample Care Label Library');
      } else {
        fileSaver.saveAs(res, 'Care Label Library');
      }
    } else if (res?.data && res?.data?.errMsg) {
      toasterMsg(t(res?.data?.errMsg), 'danger');
    } else if (res?.message) {
      toasterMsg(t(res?.message), 'danger');
    }
  } catch (error) {
    console.log(error.toString());
    toasterMsg(ERROR_MESSAGE, 'danger');
  }
};

export const importCareLib = (params, t) => async () => {
  try {
    const response = await CareLabelService.uploadFile(params);
    if (response && response.code === 200 && response.data && !response?.data?.success) {
      toasterMsg(t(`BOM_LIBRARY_VIEW.${response.message}`), 'success');
    } else if (response && response.code === 200 && response.data && response?.data?.success) {
      toasterMsg(t(`BOM_LIBRARY_VIEW.${response.message}`), 'danger');
    } else {
      toasterMsg(t(response.data.errMsg), 'danger');
    }
    return response;
  } catch (err) {
    toasterMsg(err, 'danger');
  }
};
